import React from "react";
import "./FeatureCard.css";

interface FeatureCardProps {
  color: string;
  iconSrc: string;
  label: string;
  body: string;
}

const FeatureCard: React.FC<FeatureCardProps> = ({color, iconSrc, label, body}) => {
  return (
    <div className="feature-card">
      <div className="icon-box" style={{ backgroundColor: color }}>
        <img alt="Feature icon" src={iconSrc}/>
      </div>
      <p className="label-regular mb-1.5">{label}</p>
      <p>{body}</p>
    </div>
  )
}

export default FeatureCard;